import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { TableRowStyled } from './WarehouseMemoizedTableRow.styled';
const WarehouseMemoizedTableRow = ({ index, item, context, itemContent, 
/*rowContent,*/ ...tableRowProps }) => {
    return _jsx(TableRowStyled, { ...tableRowProps, children: itemContent?.(index, item, context) });
};
const WarehouseMemoizedTableRowMemoized = memo(WarehouseMemoizedTableRow, arePropsEqual);
function arePropsEqual(prevProps, nextProps) {
    return prevProps.index === nextProps.index && prevProps.item === nextProps.item;
}
export { WarehouseMemoizedTableRowMemoized };
